import { Box } from '@mui/material';
import { notUndefiend, valueAsString } from 'helpers/conversions';
import React, { useRef } from 'react';
import { ICardProps, StatsData } from './Card';
import { Spinner, SpinnerContainer } from './Styles';
import { ReactComponent as ArrowUp } from '../../assets/icons/ArrowUp.svg';
import { styles } from './ProductionRateCardMobileDtg.styles';

const ProductionRateCardMobileDtg = (props: ICardProps) => {
  const {
    value,
    units,
    description,
    icons,
    stats,
    statsDescription,
    addedData,
    isPercentage,
  } = props;
  const isNegative = React.useMemo(() => {
    if (!notUndefiend([stats])) {
      return false;
    }
    if (stats! < 0) {
      return true;
    }
    if (description === 'Average Availability' && value !== undefined && value >= 0.999) {
      return false;
    }
    return false;
  }, [description, stats, value]);
  const rightColumnRef = useRef(null);
  const [rightColumnWidth, setRightColumnWidth] = React.useState(0);
  React.useEffect(() => {
    if (notUndefiend([stats]) && addedData) {
      if (rightColumnRef.current) {
        const { width } = rightColumnRef.current.getBoundingClientRect();
        setRightColumnWidth(width);
      }
    }
  }, [stats, addedData]);
  const hasAddedData = !!addedData;
  return (
    <Box
      display="flex"
      justifyContent="space-between"
      width="100%"
      height="100%"
      boxSizing="border-box"
      data-testid="production-rate-card-mobile">
      {notUndefiend([value]) ? (
        <>
          <Box
            display="flex"
            flexDirection="column"
            justifyContent="space-between"
            width={hasAddedData ? 'auto' : '100%'}
            height="100%"
            boxSizing="border-box"
            sx={styles.leftColumn}
            data-testid="left-column">
            <Box
              display="flex"
              flexDirection="column"
              height="70px"
              boxSizing="border-box"
              data-testid="upper-row">
              <Box display="flex" alignItems="flex-start" data-testid="value-sub-row">
                <Box sx={styles.icon} data-testid="icon-container">
                  {isNegative ? icons.negative : icons.positive}
                </Box>

                <Box sx={styles.value(value)} data-testid="production-rate-value">
                  {valueAsString(value, isPercentage)}
                </Box>
                <Box sx={styles.units} data-testid="production-rate-units">
                  {units}
                </Box>
              </Box>
              <Box
                display="flex"
                justifyContent="flex-start"
                alignItems="flex-start"
                sx={styles.leftColUpperRowDescriptionSubRow}
                data-testid="description-sub-row">
                {description}
              </Box>
            </Box>
            <Box
              display="flex"
              alignItems="flex-end"
              height="30px"
              boxSizing="border-box"
              sx={styles.leftColBottomRow}
              data-testid="production-rate-description">
              {notUndefiend([stats]) && StatsData(stats)} {statsDescription}
            </Box>
          </Box>

          {hasAddedData && (
            <Box
              display="flex"
              flexDirection="column"
              alignItems="flex-start"
              height="100%"
              boxSizing="border-box"
              sx={styles.rightColumn}
              ref={rightColumnRef}
              data-testid="right-column">
              <Box
                display="flex"
                flexDirection="column"
                boxSizing="border-box"
                sx={styles.rightColumnRow}
                data-testid="upper-row-right">
                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="baseline"
                  width={rightColumnWidth}
                  data-testid="upper-value-row">
                  <Box
                    display="flex"
                    justifyContent="flex-start"
                    sx={styles.valueAndUnitWrapper}
                    data-testid="value-unit-wrapper">
                    <Box sx={styles.rightColumnRowValueSubRowItemValue} data-testid="added-value">
                      {addedData.upper.formatter
                        ? addedData.upper.formatter(addedData.upper.value)
                        : valueAsString(addedData.upper.value!)}
                    </Box>
                    <Box sx={styles.rightColumnRowValueSubRowItemUnits} data-testid="added-units">
                      {addedData.upper.unit}
                    </Box>
                  </Box>

                  <Box data-testid="upper-arrow-icon">
                    {addedData.upper.trend !== 0 && addedData.upper.trend !== undefined && (
                      <ArrowUp
                        width={14}
                        height={18}
                        style={{ transform: addedData.upper.trend < 0 ? 'rotate(180deg)' : '' }}
                      />
                    )}
                  </Box>
                </Box>
                <Box
                  sx={styles.rightColumnRowDescriptionSubRow}
                  data-testid="added-stats-description">
                  {addedData.upper.description}
                </Box>
              </Box>

              {addedData.lower && (
                <Box
                  display="flex"
                  flexDirection="column"
                  boxSizing="border-box"
                  data-testid="lower-row-right">
                  <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="baseline"
                    width={rightColumnWidth}
                    data-testid="lower-value-row">
                    <Box
                      display="flex"
                      justifyContent="flex-start"
                      sx={styles.valueAndUnitWrapper}
                      data-testid="lower-value-unit-wrapper">
                      <Box
                        sx={styles.rightColumnRowValueSubRowItemValue}
                        data-testid="added-lower-value">
                        {addedData.lower.formatter
                          ? addedData.lower.formatter(addedData.lower.value)
                          : valueAsString(addedData.lower.value!)}
                      </Box>
                      <Box
                        sx={styles.rightColumnRowValueSubRowItemUnits}
                        data-testid="added-lower-units">
                        {addedData.lower.unit}
                      </Box>
                    </Box>

                    <Box data-testid="lower-arrow-icon">
                      {addedData.lower.trend !== 0 && addedData.lower.trend !== undefined && (
                        <ArrowUp
                          width={14}
                          height={18}
                          style={{ transform: addedData.lower.trend < 0 ? 'rotate(180deg)' : '' }}
                        />
                      )}
                    </Box>
                  </Box>
                  <Box
                    sx={styles.rightColumnRowDescriptionSubRow}
                    data-testid="added-lower-stats-description">
                    {addedData.lower.description}
                  </Box>
                </Box>
              )}
            </Box>
          )}
        </>
      ) : (
        <SpinnerContainer>{Spinner()}</SpinnerContainer>
      )}
    </Box>
  );
};
export default ProductionRateCardMobileDtg;
